<template>
  <div class="info-box">
    <p class="note">
      <strong>
        Clique nos 3 pontinhos (<i class="icofont-navigation-menu"></i>)
      </strong>
      ao lado do município para abrir o modal de detalhamento avançado.
    </p>

    <p class="mb-0">
      <strong>Fonte</strong>:
      <a href="https://siaps.saude.gov.br/publico" target="_blank">Siaps</a>, 3
      jul. 2026.
    </p>
  </div>
</template>

<script>
export default {
  name: 'RankingInfoBox',

  props: {
    info: {
      type: Object,
      default: () => ({
        type: '',
        title: '',
      }),
    },
  },
}
</script>

<style scoped>
.info-box {
  background: #eff6ff;
  border: 1px solid #dbeafe;
  color: #1e40af;
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 20px;
  font-size: 14px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
}

.note {
  display: block;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 700;
}

.note i {
  color: #2563eb;
}

.note strong {
  color: #1e40af;
}

@media (min-width: 992px) {
  .info-grid {
    grid-template-columns: 1fr 1fr;
  }
}
</style>
